// FILTERS getters
export default {
  get_sidebar_isOpened: (state) => state.sidebar.isOpened,
  get_is_custom_name: (state) => state.customName,
  get_table_actions: (state) => state.tableActions,
  get_is_new_filter: (state) => state.isNewFilter,
  get_sidebar_table_name: (state) => state.tableName,
  // get_filters_menu: (state) => state.filtersMenu,
  // get_filter_fields: (state) => state.filterFields,
  get_temporary_fields: (state) => state.temporaryFields,
  // get_active_filter: (state) => state.activeFilter,
  // get_active_tmp_filter: (state) => state.activeTmpFilter,
  get_active_filter_name: (state) => state.activeFilterName,
  get_search_term: (state) => state.search,
  // NEW DATA
  get_sidebar_table_api: (state) => state.sidebarTableApi,
  get_table_api: (state) => state.tableApi,
  get_sidebar_fields: (state) => state.sidebarFields,
  get_filters_menu: (state) => state.filtersMenu,
  get_active_filter: (state) => state.activeFilter,
  get_all_shipments_query: (state) => state.allShipmentSearchQuery,
  get_data_no_found_status: (state) => state.dataNotFound,
};
